import { Check } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';

const IMG =
  'https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMGFwYXJ0bWVudHxlbnwwfHx8fDE3OTA2MDU1MjF8MA&ixlib=rb-4.1.0&q=85';

const PILLARS = [
  'Corporate clients, professionals, families & trusted guests',
  'Fully serviced, maintained to an exceptional standard',
  'Guaranteed rental income, completely hands-off',
];

export default function About() {
  return (
    <section id="about" className="theme-light t-bg relative py-28 lg:py-40" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 md:px-12 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <div className="t-border-strong absolute -left-4 -top-4 h-full w-full rounded-2xl border" aria-hidden="true" />
            <div className="group relative overflow-hidden rounded-2xl shadow-[0_24px_60px_rgba(21, 85, 51, 0.18)]">
              <img
                src={IMG}
                alt="Beautifully maintained living space"
                data-testid="about-image"
                className="h-[440px] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#155533]/50 to-transparent" />
              <p className="mono-label absolute bottom-5 left-5 text-[#F3E9D7]/90">Maintained to hotel standard</p>
            </div>
          </div>
        </Reveal>
        <div className="lg:col-span-6 lg:col-start-7">
          <SectionHeading label="About Us" title="Your property in safe, professional hands" />
          <Reveal delay={0.15}>
            <p className="t-text2 mt-8 text-base font-light leading-relaxed sm:text-lg" data-testid="about-body">
              At THE GATE STAYS, we specialise in leasing high-quality properties directly from landlords to house our
              corporate clients, working professionals, families on vacation and trusted guests — all in need of
              quality, fully serviced accommodation. We provide a completely hands-off experience, keeping your
              property to an exceptional standard while delivering guaranteed rental income.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <ul className="mt-10 space-y-4">
              {PILLARS.map((p, i) => (
                <li key={p} className="flex items-center gap-4" data-testid={`about-pillar-${i}`}>
                  <span className="t-chip t-border-strong flex h-7 w-7 shrink-0 items-center justify-center rounded-full border">
                    <Check size={13} className="t-accent-text" />
                  </span>
                  <span className="t-soft text-sm font-light sm:text-base">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
